export default {
  methods: {
    iriToUuid(iri) {
      return /[^/]*$/.exec(iri)[0] ?? '';
    },
  },
};
